<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-30 16:01:08
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-02-02 16:43:23
 * @Description: 附件列表
-->
<template>
  <div>
    <div class="uploadFile">
      <UploadFile
        v-if="showUpload"
        ref="uploadFile"
        :limit="20"
        buttonText="点击上传附件"
        :beforeUpload="beforeUpload"
        tip="单个文件大小不能超过100mb,且上传文件个数不超过20个"
        @onSuccess="onSuccess"
        :showFileList="false"
      />
    </div>
    <el-table border :data="list" style="width: 100%" max-height="400">
      <el-table-column prop="name" label="资源名称">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="创建人"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import UploadFile from "./file";
export default {
  props: {
    businessKey: {
      type: String,
      default: "",
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    isCC: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UploadFile,
  },
  data() {
    return {
      list: [],
      defaultList: [],
      ossFiles: [],
    };
  },
  created() {
    this.getAttachments();
  },
  methods: {
    // 获取附件列表
    getAttachments() {
      this.$http
        .get(
          `/help/workflow/auth/v1/historic-process-instances/${this.businessKey}/attachments`,
          {
            params: { _noLoading: true },
          }
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data;
            this.defaultList = res.data;
          }
        });
    },
    // 上传前校验
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error("上传的附件不得大于100MB");
        return false;
      }
    },
    // 上传成功回调
    onSuccess(res) {
      const obj = {
        name: res.fileName,
        type: res.fileType,
        fileId: res.aliOssId,
      };
      // 正常情况
      let url = `/help/workflow/auth/v1/run-tasks/${this.$route.query.id}/attachments`;
      if (this.isCC) {
        url = `/help/workflow/v1/cc-tasks/${this.$route.query.id}/attachments`;
      }
      this.$http.post(url, obj).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message.success("新增成功");
          this.getAttachments();
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm("此操作将删除该附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .delete(`/help/workflow/auth/v1/acte-hi-attachments/${row.id}`)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.getAttachments();
              this.$message.success(res.message || "删除成功");
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadFile {
  padding: 0 0 12px 0;
}
</style>
